import template from './objective_measures_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class ObjectiveMeasuresHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class ObjectiveMeasuresHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new ObjectiveMeasuresHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'ObjectiveMeasuresHelp',
	dialog_class: ObjectiveMeasuresHelpPage,
	template: template,
	template_filename: 'translation/dialogs/objective_measures_help',
	provider: 'ps'
};